export const usd = (n, d = 2) =>
  n == null ? "—" : n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: d, maximumFractionDigits: d });

export const signed = (n, d = 2) => (n > 0 ? "+" : "") + n.toFixed(d);

export const tone = (n) => (n > 0 ? "up" : n < 0 ? "down" : "flat");

export const TONE = {
  up: "text-[#34D399] bg-[rgba(16,185,129,0.12)] border-[rgba(16,185,129,0.3)]",
  down: "text-[#F87171] bg-[rgba(239,68,68,0.12)] border-[rgba(239,68,68,0.3)]",
  flat: "text-slate-300 bg-slate-500/10 border-slate-500/30",
  UP: "text-[#34D399] bg-[rgba(16,185,129,0.12)] border-[rgba(16,185,129,0.3)]",
  DOWN: "text-[#F87171] bg-[rgba(239,68,68,0.12)] border-[rgba(239,68,68,0.3)]",
  MIXED: "text-[#FBBF24] bg-[rgba(245,158,11,0.12)] border-[rgba(245,158,11,0.3)]",
};

export const compact = (n) =>
  "$" + Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);
